import {useSession} from '../../auth/hooks/useSession';
import {useCallback} from 'react';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {setLimitReached} from '../demoSlice';

export const useDemo = () => {
  const dispatch = useAppDispatch();
  const session = useSession();

  return {
    isDemo: session?.isDemo === 'true',
    showLimitReachedDialog: useCallback(
      (options: {closable?: boolean; message?: string; title?: string; warning?: string} | null) => {
        dispatch(setLimitReached(options));
      },
      [],
    ),
  };
};
